import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import PasswordField from '../components/PasswordField';
import { resetPassword } from '../../../services/authService';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setIsSubmitting(true);

    try {
      await resetPassword({ token, password });
      setStatus('Password reset successfully. You can now sign in.');
      window.setTimeout(() => navigate('/login'), 750);
    } catch (error) {
      setStatus(error?.status === 400
        ? 'This password reset link is invalid or has expired. Request a new one.'
        : (error.message || 'Unable to reset password.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Reset password"
      subtitle="Set a fresh password to regain access."
    >
      <form onSubmit={handleSubmit} className="d-grid gap-3">
        {!token && <div className="alert alert-danger py-2 mb-0">This password reset link is invalid or has expired. Request a new one.</div>}
        <div>
          <label className="form-label" htmlFor="newPassword">
            New password
          </label>
          <PasswordField
            id="newPassword"
            name="password"
            placeholder="Create a new password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
            autoComplete="new-password"
          />
        </div>
        <div>
          <label className="form-label" htmlFor="confirmPassword">Confirm password</label>
          <PasswordField id="confirmPassword" name="confirmPassword" placeholder="Repeat your new password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required autoComplete="new-password" />
          {confirmPassword && password !== confirmPassword && <div className="text-danger small mt-1">Passwords do not match.</div>}
        </div>

        {status && (
          <div className="alert alert-info py-2 mb-0" role="status">
            {status}
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={isSubmitting || !token || password.length < 6 || password !== confirmPassword}>
          {isSubmitting ? 'Resetting password...' : 'Reset password'}
        </button>

        <div className="text-center small">
          <Link to="/login">Return to sign in</Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ResetPasswordPage;
